import React, {useEffect, useState} from "react";
import {Api} from "laravel-request";
import {Button} from "finform";
import moment from "moment";

import {TASK_FORM_TYPES} from "#app/redux/reducers/task";
import {Body} from "#app/components/Text/Typography";
import {dateStringBackendMask, GenericMomentInput} from "#app/helpers/MomentHelper";
import {useTaskTypesIcons} from "#app/pages/Relations/Contacts/hooks/useTaskTypesIcons";

import {ReactComponent as UserIcon} from "#app/assets/task/user.svg?react";
import {ReactComponent as CalendarIcon} from "#app/assets/task/calendar.svg?react";
import {ReactComponent as RepeatIcon} from '#app/assets/task/repeat.svg?react';
import {ReactComponent as AddIcon} from "#app/assets/task/buttons/add.svg?react";
import {ReactComponent as MessageIcon} from "#app/assets/task/buttons/message.svg?react";
import {ReactComponent as TelegramIcon} from "#app/assets/task/buttons/telegram.svg?react";

import {
    EventTaskButtonGrid,
    EventTaskButtonRow,
    EventTaskCardContainer,
    EventTaskCommentInfo,
    EventTaskTextInfo,
    Row
} from "#app/pages/styles";

interface EventTaskInterface {
    id: string | number | null; // могут браться из стейта (потому null), но не могут отсутствовать
    typeId: string | number | null; // могут браться из стейта (потому null), но не могут отсутствовать
    setTaskType: any;
    startDate: GenericMomentInput;
    endDate: GenericMomentInput;
    comment?: string | null | undefined;
    form: any;
    onUpdate: Function;
}

interface UpdateDoneStatusRequestInterface {
    is_done: boolean;
    id: string | number | null;
    end_at: string | null | undefined;
    start_at: string | null | undefined;
}

const EventTaskForm: React.FC<EventTaskInterface> = ({
                                                         id,
                                                         typeId,
                                                         setTaskType,
                                                         startDate,
                                                         endDate,
                                                         form,
                                                         onUpdate
                                                     }) => {
    const {iconsList, currentIcon, setIcon} = useTaskTypesIcons(null);
    const [contactState, setContactState]: any = useState(null);

    const [isDone, setIsDone] = useState(false);
    const [disabledOnLoad, setDisabledOnLoad] = useState(false);

    const buttonsList = [
        {title: 'Написать в чат', icon: <TelegramIcon/>, action: null},
        {title: 'Написать письмо', icon: <MessageIcon/>, action: null},
        {title: 'Добавить дело', icon: <AddIcon/>, action: null},
        {title: 'Добавить задачу', icon: <AddIcon/>, action: null},
    ];

    useEffect(() => {
        setIcon(typeId);
    }, [typeId]);

    useEffect(() => {
        const {user, contact, is_done} = form;
        user && setContactState(user);
        contact && setContactState(contact);
        setIsDone(is_done);
    }, [form]);

    const updateTaskRequest = (): void => {
        const startForSend: moment.Moment = moment(startDate);
        const endForSend: moment.Moment = moment(endDate);
        const requestData: UpdateDoneStatusRequestInterface = {
            is_done: !isDone,
            id: id,
            end_at: dateStringBackendMask(endForSend),
            start_at: dateStringBackendMask(startForSend),
        };

        Api.putArg('crm-contact-task', 'update', id, requestData).call(
            (response: any): void => {
                if (response.result && response.result === 'success') {
                    setIsDone(!isDone);
                    onUpdate();
                }
            },
            ((error: any) => console.log(error)),
            ((): void => setDisabledOnLoad(false))
        );
    }

    const handleSetToEdit = () => {
        setTaskType(TASK_FORM_TYPES.EDIT)
    }

    const handleSetToExecuted = (): void => {
        setDisabledOnLoad(true);
        updateTaskRequest();
    }

    return (
        <React.Fragment>
            <EventTaskCardContainer>
                <EventTaskTextInfo>
                    <Row className={`event__row`}>
                        <div className={`event__type`}>
                            {currentIcon.icon}
                            <span>{currentIcon.text}</span>
                        </div>
                        {contactState && (
                            <div className={`event__subject`}>
                                <UserIcon/>
                                <span>{contactState?.last_name} {contactState?.first_name}</span>
                            </div>
                        )}
                    </Row>
                    <Row className={`event__row justify__space-between`}>
                        {startDate && endDate && (
                            <div className={`event__calendar`}>
                                <CalendarIcon/>
                                <span>
                                {moment(startDate).isValid() && moment(endDate).isValid() ? (
                                    <>
                                        {moment(startDate).format('DD.MM.YYYY HH:mm')} - {moment(endDate).format('DD.MM.YYYY HH:mm')}
                                    </>
                                ) : (
                                    <span className={'invalid-date__placeholder'}>Дата не указана</span>
                                )}
                            </span>
                            </div>
                        )}

                        <div className={`event__repeat`}>
                            <span><RepeatIcon/></span>
                            <span>Повторять ежедневно</span>
                        </div>
                    </Row>
                </EventTaskTextInfo>

                <EventTaskCommentInfo>
                    <Body darkGrey style={{marginLeft: '0', width: '100%', textAlign: 'left'}}>
                        Комментарий
                    </Body>
                    <div className={`event_comment`}>
                        {form?.comment ?? ''}
                    </div>
                </EventTaskCommentInfo>

                <EventTaskButtonGrid className={`event_buttons-grid`}>
                    {buttonsList.map((button) => {
                        return (
                            <Button type={`block`} narrow onClick={button.action}>
                                {button.icon}
                                <span>{button.title}</span>
                            </Button>
                        )
                    })}
                </EventTaskButtonGrid>

                <EventTaskButtonRow>
                    <Button type={`block`} narrow onClick={handleSetToEdit}>Редактировать</Button>
                    <Button
                        narrow
                        onClick={handleSetToExecuted}
                        disabled={disabledOnLoad}
                    >
                        {(disabledOnLoad) ? 'Подождите...' : (isDone) ? 'Не выполнено' : 'Выполнено'}
                    </Button>
                </EventTaskButtonRow>
            </EventTaskCardContainer>
        </React.Fragment>
    )
}

export default EventTaskForm;